export type GoogleAnalyticsSectionId = 'account-mode';

export interface GoogleAnalyticsSectionDef {
  id: GoogleAnalyticsSectionId;
  label: string;
  description: string;
}

export const GOOGLE_ANALYTICS_SECTION_REGISTRY: readonly GoogleAnalyticsSectionDef[] = [
  {
    id: 'account-mode',
    label: 'Account mode',
    description: 'Active users and events split by creator, brand, and agency.',
  },
] as const;

export const DEFAULT_GOOGLE_ANALYTICS_SECTION_ID: GoogleAnalyticsSectionId = 'account-mode';

/** URL segment under `/admin-options/google-analytics/` for each section. */
export const GOOGLE_ANALYTICS_SECTION_ROUTE_SEGMENTS: Record<GoogleAnalyticsSectionId, string> = {
  'account-mode': 'account-mode',
};

export function getGoogleAnalyticsSectionPath(sectionId: GoogleAnalyticsSectionId): string {
  return `/admin-options/google-analytics/${GOOGLE_ANALYTICS_SECTION_ROUTE_SEGMENTS[sectionId]}`;
}

export function isGoogleAnalyticsSectionRouteActive(
  sectionId: GoogleAnalyticsSectionId,
  url: string,
): boolean {
  const path = getGoogleAnalyticsSectionPath(sectionId);
  return url === path || url.startsWith(`${path}/`);
}

export function getGoogleAnalyticsSectionById(
  id: GoogleAnalyticsSectionId,
): GoogleAnalyticsSectionDef | undefined {
  return GOOGLE_ANALYTICS_SECTION_REGISTRY.find((section) => section.id === id);
}

export function getActiveGoogleAnalyticsSectionId(url: string): GoogleAnalyticsSectionId | null {
  for (const section of GOOGLE_ANALYTICS_SECTION_REGISTRY) {
    if (isGoogleAnalyticsSectionRouteActive(section.id, url)) {
      return section.id;
    }
  }
  return null;
}

export function getActiveGoogleAnalyticsSection(url: string): GoogleAnalyticsSectionDef | undefined {
  const id = getActiveGoogleAnalyticsSectionId(url);
  return id ? getGoogleAnalyticsSectionById(id) : undefined;
}
